export default __webpack_public_path__ + "static/media/mp.c7d80099.svg";